import actionTypes from '../constants/action-types';

const setScrollStatus = (isScrolling) => ({
  type: actionTypes.SET_SCROLL_STATUS,
  payload: {
    isScrolling,
  },
});

export default setScrollStatus;
